import axios from "axios";
import swal from "sweetalert2";
import router from "../routes/router";
import jwt from "jsonwebtoken";
import { getStorage } from "./storage";
import crypto from "crypto";
let test;
const util = {
  logoutOnRefresh() {
    console.log("logout");
    let jwtToken = JSON.parse(
      atob(localStorage.getItem("token").split(".")[1])
    );
    let id = jwtToken.employeeid;
    let options = Object.assign({}, options, {
      data: null,
      method: "GET",
    });
    localStorage.removeItem("token");
    sessionStorage.removeItem("remember");
    sessionStorage.removeItem("collectiondate");
    sessionStorage.removeItem("datasubmitted");
    let url = process.env.VUE_APP_API_URL + ":9992/auth/staff/logout/" + id;
    axios(url, options)
      .then((res) => {
        console.log(res);
      })
      .catch((err) => {
        console.log(err);
      });
  },
  stopPing() {
    clearInterval(test);
  },
  tokenPing() {
    console.log("token ping");

    if (localStorage.getItem("token") != null) {
      let jwtToken = JSON.parse(
        atob(localStorage.getItem("token").split(".")[1])
      );
      let id = jwtToken.employeeid;
      let options = Object.assign({}, options, {
        data: null,
        method: "GET",
      });

      // test = setInterval(() => {
      //   let url =
      //     process.env.VUE_APP_API_URL + ":9992/auth/staff/tokencheck/" + id;
      //   axios(url, options)
      //     .then((res) => {
      //       console.log(res.data.error);
      //       if (res.data.error) {
      //         localStorage.removeItem("token");
      //         clearInterval(test);
      //         swal({
      //           title: "Invalid session",
      //           text: "Session revoked , please relogin",
      //           type: "error",
      //           confirmButtonClass: "btn btn-primary btn-fill",
      //           buttonsStyling: false,
      //         });

      //         setTimeout(() => {
      //           router.push("/login");
      //           swal.close();
      //         }, 10000);
      //         //logout
      //       } else {
      //       }
      //     })
      //     .catch((err) => {
      //       console.log(err);
      //     });
      // }, 60000);
    }

    if (
      localStorage.getItem("token") != null ||
      localStorage.getItem("token") == undefined
    ) {
      this.$router.push("/login");
    }
  },
  decodedToken() {
    const token = getStorage("token");
    try {
      return JSON.parse(atob(token.split(".")[1]));
    } catch (error) {
      console.error("Error", error);
      return null;
    }
  },
  encrypt(plainText) {
    const key = process.env.VUE_APP_ENCRYPT_KEY;
    // Generate a random IV (Initialization Vector)
    const iv = crypto.randomBytes(16);

    // Create a new AES cipher block using the key and IV
    const block = crypto.createCipheriv("aes-192-cbc", Buffer.from(key), iv);

    // Padding the plaintext using PKCS#7
    const padding = Buffer.alloc(
      16 - ((plainText.length + 3) % 16),
      16 - (plainText.length % 16)
    );
    const lenPadding = Buffer.alloc(
      3 - (plainText.length.toString().length % 3),
      "0"
    );

    const paddedText = Buffer.concat([
      lenPadding,
      Buffer.from(plainText.length.toString()),
      Buffer.from(plainText),
      padding,
    ]);
    // Encrypt the padded plaintext
    const encryptedBuffer = Buffer.concat([
      block.update(paddedText),
      block.final(),
    ]);

    // Combine IV and ciphertext and encode in base64
    const result = Buffer.concat([iv, encryptedBuffer]).toString("base64");
    return result;
  },
  capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  },
};

export default util;
